export default "__VITE_ASSET__CMoadVt$__"